import type { FC } from "react";

import { BillsAndDiscountsIcon } from "@jti/brand-icons/bills-and-discounts";
import { SkeletonText } from "@jti/core-components/components/SkeletonText/SkeletonText";

import styles from "./StatusMessage.module.scss";

export type StatusMessageProps = {
  message: string;
  isLoading?: boolean;
};

export const StatusMessage: FC<StatusMessageProps> = ({ message, isLoading }) => (
  <div className={styles.statusMessage}>
    <span className={styles.statusIcon} aria-hidden="true">
      <BillsAndDiscountsIcon />
    </span>
    {isLoading ? (
      <div className={styles.statusLoading}>
        <SkeletonText rows={1} fullWidth />
      </div>
    ) : (
      <span>{message}</span>
    )}
  </div>
);
